
<template>
  <div>
    <!-- <default-dialog :dialog="true" :loading="loading">   -->
      <!-- :loading="loading" -->
      <!-- <template slot="title">
        Detalhes do pagamento
      </template>
      <template slot="content"> -->
        
        
        <div v-if="item.order_id || ['payment', 'bill', 'pix'].includes(item.type) " class="py-3">
          <v-btn small outlined color="primary" @click="itemClicked(item)" rounded v-if="item.type != 'vrt_transaction'">
            Ver detalhes do pagamento
            <v-icon small right>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
        <div>
          <b>{{item.type=='vrt_transaction' ? 'Pagamentos' : 'Faturas'}} relacionados</b>
        </div>
        <template v-if="loading">
          <v-alert type="info" :value="true">
            Carregando...
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>
        </template>
        <template v-if="!loading && traces.length==0">
          <v-alert type="info" :value="true">
            Sem nenhum registro de {{item.type=='vrt_transaction'? 'pagamentos' : 'faturas'}}
          </v-alert>
        </template>
        <template v-if="!loading && traces.length!=0">
          <list-item-trace :hf="item" :list_of="item.type" :traces="traces" @orderClicked="handleOrderClicked" @detailsClick="handleDetailsClick" ></list-item-trace>
        </template>
          <!-- <v-layout v-for="trace in traces" :key="trace.id" style="border-bottom: solid #ddd 1px;" align-center > -->
            <!-- <v-flex xs1>#{{trace.id}}</v-flex> -->
            <!-- <v-flex xs2 v-if="hf.type=='vrt_transaction'">{{trace.traceable_type}}</v-flex> -->
            <!-- <v-flex xs2 v-if="hf.type!='vrt_transaction'">Fatura</v-flex> -->
            <!-- <v-flex>valor: {{Number(trace.value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</v-flex> -->
            <!-- <v-flex>pago em: {{$moment(trace.created_at.substring(0,10)+'T12:00:00').format('l')}}</v-flex> -->
            <!-- <v-flex><v-btn small color="primary" @click="do_method()" outlined rounded><v-icon left small>fa-plus</v-icon> detalhes</v-btn></v-flex> -->
          <!-- </v-layout> -->
        

      <!-- </template>
      <template slot="actions">
        <f-btn cancel @click="$emit('closeItem')"></f-btn>
      </template>
    </default-dialog> -->


    <dialog-item-trace :list_of="one_trace.type" :trace="one_trace" @orderClicked="handleOrderClicked" v-if="dialog_details" @close='handleClose' ></dialog-item-trace>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'
import Api from '@/api/index';
import ListItemTrace from '@/_backoffice/_registrations/components/client/pay_traces/ListItemTrace.vue'
import DialogItemTrace from '@/_backoffice/_registrations/components/client/pay_traces/DialogItemTrace.vue'


export default {
  components: { ListItemTrace, DialogItemTrace },
  mixins: [SolutionMap],
  name: 'ItemHistoricContent',
  props: {
    item: {
      type: Object,
    },
    financial_data:{
      type: Object
    }
  },
  data() {
    return {
      item_dialog: true,
      traces:[],
      loading: false,
      dialog_details: false,
      one_trace: {},
      element: {},
      loading: true,
    }
  },
  methods: {
    itemClicked(item_hf){
      // console.log({item_hf});
      this.$emit('itemClicked', item_hf)
    },
    handleOrderClicked(order_id){
      this.$emit('itemClicked', {order_id})
    },
    handleDetailsClick(item){
      this.dialog_details = true
      this.one_trace = {...item}
      // this.element = {...item.element}
    },
    handleClose(){
      this.dialog_details = false
      this.one_trace = {}
      this.element = {}
    },
    getTraces(){
      if (this.traces.length == 0){
        this.loading = true
        let filter = {}
        if (['payment', 'pix', 'bill', 'exchange'].includes(this.item.type) ){
          filter.trace_type = this.item.kind 
          filter.trace_id = this.item.id
        } else if (this.item.type == 'vrt_transaction'){
          filter.by_vrt_id = this.item.id
        }
        if (!Object.keys(filter).length){
          this.loading = false
          return
        }
        Api.PayTrace.index(filter).then(r=>r.data).then(d=>{
          this.traces = [...d, ...this.traces]
        }).finally(()=>{
          this.loading = false
        })
      }
    },
  },
  mounted () {
    this.getTraces();
  },
}
</script>